import { roundToTwoDecimals } from '../../Utils/decimalUtils';
import type { AdjustmentSpec } from './PriceSimulation.types';

export const isRelativeInput = (raw: string | null | undefined): boolean => {
    const trimmed = (raw ?? '').trim();
    return trimmed.length > 1 && (trimmed[0] === '+' || trimmed[0] === '-');
};

export const parseDecimalInput = (raw: string | null | undefined): number => parseFloat((raw ?? '').replace(/\s/g, '').replace(',', '.'));

export const parsePriceInput = (raw: string | null | undefined, base: number): number => {
    const num = parseDecimalInput(raw);
    if (Number.isNaN(num)) return base;
    return roundToTwoDecimals(isRelativeInput(raw) ? base + num : num);
};

export const parsePercentInput = (raw: string | null | undefined): number => roundToTwoDecimals(parseDecimalInput(raw) || 0);

export const applyAdjustmentSpec = (base: number, spec: AdjustmentSpec): number =>
    roundToTwoDecimals(spec.kind === 'percent' ? base * (1 + spec.percent / 100) : base + spec.delta);

export default parsePriceInput;
